import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	background: var(--white);
	width: 62rem;

	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);

	@media ${Breakpoints.mobile} {
		border: none;
		width: 100%;
	}
`;

export const Content = styled.div`
	width: 62rem;
	padding: 2rem 3rem;
	@media ${Breakpoints.mobile} {
		width: 100%;
		padding: 0;
		padding-top: 2rem;
	}
`;

export const ButtonLink = styled(Button)`
	> .typography {
		text-decoration: underline;
	}
`;

export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;

	> .form-item {
		padding: 0;
	}

	@media ${Breakpoints.tablet} {
		width: 80%;
	}

	@media ${Breakpoints.mobile} {
		width: 100%;
	}
`;

export const ForgotPasswordFormContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	padding: 1rem;
	border-radius: var(--small-border-radius);
	overflow: auto;

	> .typography {
		margin-left: var(--margin-2);
	}

	@media ${Breakpoints.mobile} {
		padding: var(--padding-2) var(--padding-3);
		border: none;
	}
`;

export const FormElemContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	width: 100%;
	max-width: 500px;

	> .form-item {
		padding: 0;
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	padding: 2rem 0;
	width: fit-content;
	margin: auto;
	flex-wrap: wrap;

	@media ${Breakpoints.mobile} {
		padding: 0;
	}
`;

export const Seperator = styled.div`
	margin: 1rem 0 2rem 0;
	height: 1px;
	min-height: 1px;
	border-top: 1px solid #727272;
	text-align: center;
	opacity: 0.5;

	> .typography {
		position: relative;
		top: -0.7em;
		color: #727272;
		padding-right: 1.5rem;
		padding-left: 1.5rem;
		background: var(--white);
		display: inline-block;
	}
`;

export const PasswordValidationContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
`;

export const PasswordRequirement = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	width: 50%;
	padding: var(--padding-1) 0;

	@media ${Breakpoints.mobile} {
		width: 100%;
	}
`;

export const AgreementContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;

	:hover {
		cursor: pointer;

		> input[type='checkbox'] {
			cursor: pointer;
		}
	}
`;

export const MFAContent = styled.div`
	width: 62rem;
	padding: 0 3rem;
	@media ${Breakpoints.mobile} {
		width: 100%;
		padding: 0;
		padding-top: 2rem;
	}
`;

export const MFATitleContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 3rem 0 2rem 0;
	gap: 1rem;
`;

export const OTPContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3rem;
	padding: 2rem 0;

	> .otp-input {
		justify-content: center;
	}
`;

export const ConfirmButton = styled(Button)`
	margin: 2rem 0;
`;

export const MFABottomButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	padding-bottom: 3rem;
	width: fit-content;
	margin: auto;
	flex-wrap: wrap;

	@media ${Breakpoints.mobile} {
		padding: 0;
	}
`;

export const SecurityRequirementsWrapper = styled.div`
	display: flex;
`;

export const SecurityRequirementsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	width: 100%;
	max-width: max-content;
	gap: 2rem;
	padding: 1rem;

	@media ${Breakpoints.mobile} {
		padding: 0.5rem;
		gap: 0.5rem;
		grid-template-columns: repeat(1, 1fr);
	}
`;

export const SecurityRequirementsItem = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	gap: 1rem;

	@media ${Breakpoints.mobile} {
		gap: 0.5rem;
	}
`;
